import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import BestsellersSection from "@/components/BestsellersSection";
import BenefitsSection from "@/components/BenefitsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import TrustBadges from "@/components/TrustBadges";
import CTASection from "@/components/CTASection";
import NewCustomerBanner from "@/components/NewCustomerBanner";
import SEO from "@/components/SEO";
import { OrganizationSchema, WebSiteSchema } from "@/components/JsonLd";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Premium Auto & Motor Detailing Producten"
        description="Alienjuice levert premium detailing producten voor auto's en motoren. Professionele snow foam, shampoo, ceramic coating en velgenreiniger. Gratis verzending vanaf €50."
        canonical="/"
      />
      <OrganizationSchema />
      <WebSiteSchema />
      <Header />
      <main>
        <NewCustomerBanner />
        <HeroSection />
        <TrustBadges />
        <BestsellersSection />
        <BenefitsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
